
        import { auth, db, googleProvider, twitterProvider, signInWithPopup, createUserWithEmailAndPassword, signInWithEmailAndPassword } from './firebase.js';
        import { saveDraft, updateDraft, getDrafts, deleteDraft, getDraft } from './drafts.js';
        import { onAuthStateChanged } from './firebase.js';

        // Make these objects available globally
        window.auth = auth;
        window.db = db;
        window.googleProvider = googleProvider;
        window.twitterProvider = twitterProvider;
        window.signInWithPopup = signInWithPopup;
        window.createUserWithEmailAndPassword = createUserWithEmailAndPassword;
        window.signInWithEmailAndPassword = signInWithEmailAndPassword;

        // Make draft functions available globally
        window.saveDraft = saveDraft;
        window.updateDraft = updateDraft;
        window.getDrafts = getDrafts;
        window.deleteDraft = deleteDraft;
        window.getDraft = getDraft;

        // Add this listener to persist auth state
        onAuthStateChanged((user) => {
            if (user) {
                window.currentUser = user;
                updateAuthUI();
            } else {
                window.currentUser = null;
                updateAuthUI();
            }
        });

        // Define your sign-in functions here
        window.handleGoogleSignIn = async function() {
            try {
                showLoading(true);
                console.log("Starting Google sign-in process");
                const result = await signInWithPopup(auth, googleProvider);
                console.log("Google sign-in successful", result);
                window.currentUser = result.user;
                clearAuthInputs();
                console.log("Calling updateAuthUI");
                updateAuthUI();
            } catch (error) {
                console.error("Error signing in with Google:", error);
                showError(getErrorMessage(error), 'auth');
            } finally {
                showLoading(false);
            }
        }

        // Add this new function for Google Sign Up
        window.handleGoogleSignUp = async function() {
            try {
                const result = await signInWithPopup(auth, googleProvider);
                // Handle successful sign-up
                window.currentUser = result.user;
                clearAuthInputs();
                updateAuthUI();
                showError("Successfully signed up with Google!", 'auth');
            } catch (error) {
                console.error("Error signing up with Google:", error);
                showError(getErrorMessage(error), 'auth');
            }
        }

        window.handleTwitterSignIn = async function() {
            try {
                showLoading(true);
                const result = await signInWithPopup(auth, twitterProvider);
                window.currentUser = result.user;
                
                // Log the entire result object to inspect its structure
                console.log("Twitter sign-in result:", result);
                console.log("User object:", result.user);
                console.log("Additional user info:", result.additionalUserInfo);

                // Try different possible locations for the Twitter handle
                const twitterHandle = 
                    result.additionalUserInfo?.username ||
                    result.user?.reloadUserInfo?.screenName ||
                    result.user?.providerData[0]?.screenName ||
                    result.user?.displayName;

                console.log("Retrieved Twitter handle:", twitterHandle);

                if (twitterHandle) {
                    localStorage.setItem('twitterHandle', twitterHandle);
                } else {
                    console.error("Could not retrieve Twitter handle");
                }

                clearAuthInputs();
                updateAuthUI();
            } catch (error) {
                console.error("Error signing in with Twitter:", error);
                if (error.code === 'auth/popup-closed-by-user') {
                    showError("Twitter sign-in was cancelled. Please try again.", 'auth');
                } else if (error.message.includes('Cross-Origin-Opener-Policy')) {
                    showError("There was an issue with the Twitter sign-in. Please try again or use another sign-in method.", 'auth');
                } else {
                    showError(getErrorMessage(error), 'auth');
                }
            } finally {
                showLoading(false);
            }
        }

        // Other necessary functions...
    